import {
  getJson,
  putJson,
  postJson
} from '../fetch';
import API_BASE_PATH from './basePath';

export const verifyEmails = (studentNumbersAndEmails) => postJson(`${API_BASE_PATH}/users/verify-emails`, studentNumbersAndEmails);

export const verifyEmail = (studentNumber, email) => verifyEmails([{ studentNumber, email }])
  .then((results) => results[0]);

export const putUserRoles = (userId, roleNames) => putJson(`${API_BASE_PATH}/users/${userId}/roles`, roleNames);

export const getUserWithRolesAndPermissions = (userId) => getJson(`${API_BASE_PATH}/users/${userId}`);

export const getUsersPage = (page, size, query, queryTarget, roles, includeRoles) => {
  let requestUrl = `${API_BASE_PATH}/users?page=${page}&size=${size}`;

  if (query) {
    requestUrl = `${requestUrl}&query=${query}`;
  }

  if (query && queryTarget) {
    requestUrl = `${requestUrl}&queryTarget=${queryTarget}`;
  }

  if (roles && roles.length) {
    requestUrl = `${requestUrl}&roles=${roles}`;
  }

  if (includeRoles) {
    requestUrl = `${requestUrl}&includeRoles=true`;
  }
  return getJson(requestUrl);
};
